module.exports = __webpack_public_path__ + "static/img/login-bg.25bf7907.png";